import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { Presenter } from "../components/onboarding/Presenter";

// Public personal onboarding link (/watch/:token): narrated presentation personalised for one business; views are tracked for the rep.
export default function WatchOnboardingPage() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const sent = useRef(-1);
  useEffect(() => { api.get(`/public/onboard/${token}`).then((r) => setD(r.data)).catch((e) => setErr(e?.response?.data?.detail || "This link isn't available")); }, [token]);
  const progress = (i, claim = false) => {
    if (!claim && i <= sent.current) return;
    if (!claim) sent.current = i;
    api.post(`/public/onboard/${token}/progress`, { slide: i, claim_click: claim, start: !claim && i === 0 }).catch(() => {});
  };
  if (err) return <div className="min-h-screen bg-[#111] flex items-center justify-center text-white font-serif text-2xl p-6 text-center" data-testid="watch-error">{err}</div>;
  if (!d) return <div className="min-h-screen bg-[#111]" />;
  return <Presenter deck={d} aud={d.audience} viewer audioBase={`/api/public/onboard/${token}/audio`} onProgress={progress} />;
}
